import * as _ from 'underscore';
import * as angular from 'angular';
import { RetailerService } from '../api/retailer.service';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { StoreInventoryResponse, StoreInventoryRequest, StoreInventoryListItem } from '../core';
import { Open360BusinessLogicItemTypesCategoryWithItemTypesAndMeasurements as categoryWithItemTypesAndMeasurements } from '../model/open360BusinessLogicItemTypesCategoryWithItemTypesAndMeasurements';

export class InventoryService {
    static $inject = ['http', '$uibModal', 'retailerService'];

    constructor(
        private http: HttpService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private retailerService: RetailerService,
    ) { }

    get = (shopID: number): angular.IPromise<StoreInventoryResponse> => {
        return this.http.get(this.retailerService.inventory(shopID));
    }

    save = (shopID: number, model: StoreInventoryRequest) => {
        return this.http.post(this.retailerService.inventory(shopID), this.toServerModel(model));
    }

    chooseCategory = (categories: StoreInventoryListItem[]): angular.IPromise<StoreInventoryListItem> => {
        return this.$uibModal.open({
            component: 'chooseCategory',
            resolve: {
                categories: () => categories
            },
            size: 'lg'
        }).result;
    }

    getClassificationDictionary() {
        return this.http.get<categoryWithItemTypesAndMeasurements[]>(this.retailerService.getClassificationDictionary());
    }

    private toServerModel = (model: StoreInventoryRequest) => {
        return {
            ClassificationCategories: _.map(model.ClassificationCategories, this.toItemModel)
        };
    }

    private toItemModel = (inventory) => {
        return {
            CategoryID: inventory.CategoryID,
        };
    }

    private newBrand(brand: any) {
        return !_.isNumber(brand.ID);
    }

    private existingBrand(brand: any) {
        return _.isNumber(brand.ID);
    }
}
angular
    .module('naut')
    .service('inventoryService', InventoryService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/inventory.service.ts